import { render, staticRenderFns } from "./HighlightedProductCard.vue?vue&type=template&id=5d59c92b&"
import script from "./HighlightedProductCard.vue?vue&type=script&lang=js&"
export * from "./HighlightedProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports